<template>
    <v-dialog v-model="isShowDialog">
        <v-card>
            <v-toolbar>
                <v-toolbar-title>ヘルプ: {{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <CloseButton @click="isShowDialog = false" />
            </v-toolbar>
            <!-- 余白:48px, ヘッダー:64px -->
            <v-card-text style="max-height: calc(100% - 48px - 64px);" class="scroll-bar">
                <slot name="contents"></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import { ref, watch } from 'vue'

export default {
    name: 'HelpDialog',
    props: ["isShow", "title"],
    setup(props, { emit }) {
        const isShowDialog = ref(false)

        // 表示を制御するために、propsの値を監視
        watch(
            () => props.isShow,
            () => {
                isShowDialog.value = props.isShow
            }
        )

        // 非表示を制御するために、isShowDialogの値を監視
        // * overlayクリック時のイベントを取得できないため ※@click:outsideが使えない
        watch(isShowDialog, (newVal) => {
            if (newVal === false) {
                emit('close')
            }
        })

        return {
            isShowDialog,
        }
    }
}
</script>
